export default [
  {
    path: "/general-settings",
    name: "general",
    component: () => import("@/views/general/View.vue"),
    meta: {
      pageTitle: "breadcrumb.general",
      navActiveLink: "general",
      resource: "general-settings",
      action: "read",
      breadcrumb: [
        {
          text: "breadcrumb.general",
          active: true,
        },
      ],
    },
  },
];
``;
